import { useState, useEffect } from 'react'
import {Cookie} from 'lucide-react'

const CONSENT_KEY = 'amanaliya_cookie_consent'

const CookieBanner = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY)
      if (!stored) {
        setVisible(true)
      }
    } catch {
      setVisible(true)
    }
  }, [])

  const saveConsent = (choice: 'all' | 'essential') => {
    try {
      localStorage.setItem(
        CONSENT_KEY,
        JSON.stringify({ choice, date: new Date().toISOString() })
      )
    } catch {
      // ignore storage errors
    }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6">
      <div className="max-w-4xl mx-auto bg-white border border-gray-200 shadow-2xl rounded-xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex-1 flex gap-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#722F37]/10 flex items-center justify-center">
              <Cookie size={20} className="text-[#722F37]" />
            </div>
            <div>
              <p className="text-sm text-gray-700 leading-relaxed">
                We use cookies to improve your experience. Essential cookies are always active. You
                can accept or decline analytics and third-party cookies.
              </p>
              <a
                href="/privacy-policy.html"
                className="inline-block mt-1.5 text-xs font-medium text-[#722F37] hover:underline"
              >
                Privacy Policy
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 sm:flex-shrink-0">
            <button
              onClick={() => saveConsent('essential')}
              className="px-5 py-2.5 text-sm font-medium rounded-lg border border-[#722F37] text-[#722F37] bg-white hover:bg-[#722F37]/5 transition-colors whitespace-nowrap"
            >
              Essential only
            </button>
            <button
              onClick={() => saveConsent('all')}
              className="px-5 py-2.5 text-sm font-medium rounded-lg bg-[#722F37] text-white hover:bg-[#5e2630] transition-colors whitespace-nowrap"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
